import React from "react";
import TextField from "@material-ui/core/TextField";

import Contents from "./EditNews/Contents.jsx";
import YoutubeEmbeded from "./EditNews/YoutubeEmbeded.jsx";
import ImageVideo from "./EditNews/ImageVideo.jsx";
import Tags from "./EditNews/Tags.jsx";
import DateFreeze from "./EditNews/DateFreeze.jsx";

import makeStyles from "@material-ui/core/styles/makeStyles";
import { useDataLayerValue } from "../Reducer/DataLayer.js";

const EditNews = (props) => {
  const classes = useStyles();

  const [state, dispatch] = useDataLayerValue();

  React.useEffect(() => {
    const getData = async () => {
      if (props?.match?.path === "/edit/:id") {
        let { id } = props?.match?.params;
        const response = await fetch(
          `/.netlify/functions/server/api/getNews/${id}`
        );
        const data = await response.json();
        await dispatch({
          type: "INITIALIZE",
          payload: { data: data[0] },
        });
      }
    };

    getData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      props?.match?.path === "/edit/:id"
        ? await fetch(
            `/.netlify/functions/server/api/updateNews/${props?.match?.params?.id}`,
            {
              method: "PUT",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(state),
            }
          )
        : await fetch("/.netlify/functions/server/api/addNews", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(state),
          });

      await dispatch({ type: "RE_INITIALIZE" });
      window.location = "/allNews";
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <>
      <h1 className="text-center mt-3">
        {props?.match?.path !== "/edit/:id" ? "Add News" : "Edit News"}
      </h1>
      <form onSubmit={(e) => handleSubmit(e)} className="px-md-5 px-4">
        {/* HEADING */}
        <TextField
          label="Heading"
          variant="filled"
          className="w-100 my-2"
          placeholder="Enter Heading in 100 words"
          value={state?.heading}
          onChange={(e) =>
            dispatch({
              type: "Add_HEADING",
              payload: {
                heading: e.target.value,
              },
            })
          }
          multiline
          required
        />

        {/* SUB-HEADING */}
        <TextField
          value={state?.subHeading}
          onChange={(e) =>
            dispatch({
              type: "Add_SUBHEADING",
              payload: {
                subHeading: e.target.value,
              },
            })
          }
          label="Sub-Heading"
          variant="filled"
          placeholder="Enter Sub-Heading in 200 words"
          className="w-100 my-2"
          multiline
        />

        <YoutubeEmbeded />

        <ImageVideo />

        <Contents />

        <div className={classes.tagAndDate}>
          <Tags />

          <DateFreeze />
        </div>

        {/* SUBMIT BUTTON */}
        <input
          type="submit"
          value={
            props?.match?.path !== "/edit/:id" ? "Add News" : "Update News"
          }
          className="form-control btn btn-primary mb-5"
        />
      </form>
    </>
  );
};

export default EditNews;

const useStyles = makeStyles(() => ({
  root: {},
  tagAndDate: {
    borderRadius: "0.5rem",
    display: "flex",
  },
}));
